// import galleryPath from '../img/feedbacs-gallery/gallery/';
const galleryPath = `${import.meta.env.BASE_URL}/img/`;
const galleryData = {
  italy: [
    {
      alt: 'italy alley',
      desktop: `${galleryPath}italy-first-desktop.webp    1x,${galleryPath}italy-first-desktop-2x.webp 2x`,
      tablet: `${galleryPath}italy-first-tablet.webp    1x,${galleryPath}italy-first-tablet-2x.webp 2x`,
      mobile: `${galleryPath}italy-first-mobile.webp    1x,${galleryPath}italy-first-mobile-2x.webp 2x`,
      img: `${galleryPath}italy-first-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}italy-second-desktop.webp    1x,${galleryPath}italy-second-desktop-2x.webp 2x`,
      tablet: `${galleryPath}italy-second-tablet.webp    1x,${galleryPath}italy-second-tablet-2x.webp 2x`,
      mobile: `${galleryPath}italy-second-mobile.webp    1x,${galleryPath}italy-second-mobile-2x.webp 2x`,
      img: `${galleryPath}italy-second-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}italy-third-desktop.webp    1x,${galleryPath}italy-third-desktop-2x.webp 2x`,
      tablet: `${galleryPath}italy-third-tablet.webp    1x,${galleryPath}italy-third-tablet-2x.webp 2x`,
      mobile: `${galleryPath}italy-third-mobile.webp    1x,${galleryPath}italy-third-mobile-2x.webp 2x`,
      img: `${galleryPath}italy-third-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}italy-fourth-desktop.webp    1x,${galleryPath}italy-fourth-desktop-2x.webp 2x`,
      tablet: `${galleryPath}italy-fourth-tablet.webp    1x,${galleryPath}italy-fourth-tablet-2x.webp 2x`,
      mobile: `${galleryPath}italy-fourth-mobile.webp    1x,${galleryPath}italy-fourth-mobile-2x.webp 2x`,
      img: `${galleryPath}italy-fourth-desktop.webp`,
    },
  ],
  australia: [
    {
      alt: 'italy alley',
      desktop: `${galleryPath}australia-first-desktop.webp    1x,${galleryPath}australia-first-desktop-2x.webp 2x`,
      tablet: `${galleryPath}australia-first-tablet.webp    1x,${galleryPath}australia-first-tablet-2x.webp 2x`,
      mobile: `${galleryPath}australia-first-mobile.webp    1x,${galleryPath}australia-first-mobile-2x.webp 2x`,
      img: `${galleryPath}australia-first-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}australia-second-desktop.webp    1x,${galleryPath}australia-second-desktop-2x.webp 2x`,
      tablet: `${galleryPath}australia-second-tablet.webp    1x,${galleryPath}australia-second-tablet-2x.webp 2x`,
      mobile: `${galleryPath}australia-second-mobile.webp    1x,${galleryPath}australia-second-mobile-2x.webp 2x`,
      img: `${galleryPath}australia-second-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}australia-third-desktop.webp    1x,${galleryPath}australia-third-desktop-2x.webp 2x`,
      tablet: `${galleryPath}australia-third-tablet.webp    1x,${galleryPath}australia-third-tablet-2x.webp 2x`,
      mobile: `${galleryPath}australia-third-mobile.webp    1x,${galleryPath}australia-third-mobile-2x.webp 2x`,
      img: `${galleryPath}australia-third-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}australia-fourth-desktop.webp    1x,${galleryPath}australia-fourth-desktop-2x.webp 2x`,
      tablet: `${galleryPath}australia-fourth-tablet.webp    1x,${galleryPath}australia-fourth-tablet-2x.webp 2x`,
      mobile: `${galleryPath}australia-fourth-mobile.webp    1x,${galleryPath}australia-fourth-mobile-2x.webp 2x`,
      img: `${galleryPath}australia-fourth-desktop.webp`,
    },
  ],
  india: [
    {
      alt: 'italy alley',
      desktop: `${galleryPath}india-first-desktop.webp    1x,${galleryPath}india-first-desktop-2x.webp 2x`,
      tablet: `${galleryPath}india-first-tablet.webp    1x,${galleryPath}india-first-tablet-2x.webp 2x`,
      mobile: `${galleryPath}india-first-mobile.webp    1x,${galleryPath}india-first-mobile-2x.webp 2x`,
      img: `${galleryPath}india-first-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}india-second-desktop.webp    1x,${galleryPath}india-second-desktop-2x.webp 2x`,
      tablet: `${galleryPath}india-second-tablet.webp    1x,${galleryPath}india-second-tablet-2x.webp 2x`,
      mobile: `${galleryPath}india-second-mobile.webp    1x,${galleryPath}india-second-mobile-2x.webp 2x`,
      img: `${galleryPath}india-second-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}india-third-desktop.webp    1x,${galleryPath}india-third-desktop-2x.webp 2x`,
      tablet: `${galleryPath}india-third-tablet.webp    1x,${galleryPath}india-third-tablet-2x.webp 2x`,
      mobile: `${galleryPath}india-third-mobile.webp    1x,${galleryPath}india-third-mobile-2x.webp 2x`,
      img: `${galleryPath}india-third-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}italy-fourth-desktop.webp    1x,${galleryPath}italy-fourth-desktop-2x.webp 2x`,
      tablet: `${galleryPath}italy-fourth-tablet.webp    1x,${galleryPath}italy-fourth-tablet-2x.webp 2x`,
      mobile: `${galleryPath}italy-fourth-mobile.webp    1x,${galleryPath}italy-fourth-mobile-2x.webp 2x`,
      img: `${galleryPath}italy-fourth-desktop.webp`,
    },
  ],
  brazil: [
    {
      alt: 'italy alley',
      desktop: `${galleryPath}brazil-first-desktop.webp    1x,${galleryPath}brazil-first-desktop-2x.webp 2x`,
      tablet: `${galleryPath}brazil-first-tablet.webp    1x,${galleryPath}brazil-first-tablet-2x.webp 2x`,
      mobile: `${galleryPath}brazil-first-mobile.webp    1x,${galleryPath}brazil-first-mobile-2x.webp 2x`,
      img: `${galleryPath}brazil-first-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}brazil-second-desktop.webp    1x,${galleryPath}brazil-second-desktop-2x.webp 2x`,
      tablet: `${galleryPath}brazil-second-tablet.webp    1x,${galleryPath}brazil-second-tablet-2x.webp 2x`,
      mobile: `${galleryPath}brazil-second-mobile.webp    1x,${galleryPath}brazil-second-mobile-2x.webp 2x`,
      img: `${galleryPath}brazil-second-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}brazil-third-desktop.webp    1x,${galleryPath}brazil-third-desktop-2x.webp 2x`,
      tablet: `${galleryPath}brazil-third-tablet.webp    1x,${galleryPath}brazil-third-tablet-2x.webp 2x`,
      mobile: `${galleryPath}brazil-third-mobile.webp    1x,${galleryPath}brazil-third-mobile-2x.webp 2x`,
      img: `${galleryPath}brazil-third-desktop.webp`,
    },
    {
      alt: 'italy alley',
      desktop: `${galleryPath}brazil-fourth-desktop.webp    1x,${galleryPath}brazil-fourth-desktop-2x.webp 2x`,
      tablet: `${galleryPath}brazil-fourth-tablet.webp    1x,${galleryPath}brazil-fourth-tablet-2x.webp 2x`,
      mobile: `${galleryPath}brazil-fourth-mobile.webp    1x,${galleryPath}brazil-fourth-mobile-2x.webp 2x`,
      img: `${galleryPath}brazil-fourth-desktop.webp`,
    },
  ],
};

const galleryButtonList = document.querySelector('.gallery-list-order');
const galleryButton = galleryButtonList.querySelectorAll(
  '.gallery-order-button'
);
const galleryPhotosItem = document.querySelectorAll('.gallery-photos-item');
const galleryOptionsPhoto = document.getElementById('gallery-options');

galleryButtonList.addEventListener('click', handleGalleryButton);
galleryOptionsPhoto.addEventListener('click', handleGalleryCountry);

function handleGalleryButton(event) {
  const btn = event.target.closest('.gallery-order-button');
  if (!btn) return;

  galleryButton.forEach(b => {
    b.classList.remove('gallery-button-active');
  });
  btn.classList.add('gallery-button-active');
}

function handleGalleryCountry(event) {
  const btn = event.target.closest('.gallery-order-button[data-country]');
  if (!btn) return;
  const countryKey = btn.dataset.country;
  showCountry(countryKey);
}

function showCountry(countryKey) {
  const item = galleryData[countryKey];
  if (!item) return;

  galleryPhotosItem.forEach((li, i) => {
    const sources = li.querySelectorAll('source');
    const img = li.querySelector('img');

    sources[0].srcset = item[i].desktop;
    sources[1].srcset = item[i].tablet;
    sources[2].srcset = item[i].mobile;

    img.src = item[i].img;
    img.alt = item[i].alt;
  });
}

showCountry('italy');
